import { render } from "./HowItWork.vue?vue&type=template&id=57f984f6&scoped=true"
import script from "./HowItWork.vue?vue&type=script&lang=js"
export * from "./HowItWork.vue?vue&type=script&lang=js"

import "./HowItWork.vue?vue&type=style&index=0&id=57f984f6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57f984f6"]])

export default __exports__